import { useEffect, useRef, useState, useCallback } from "react";

export const useActiveCarouselIndex = (itemCount, options = {}) => {
    const {
        threshold = 0.6,
    } = options;

    const containerRef = useRef(null);
    const itemRefs = useRef([]);
    const [activeIndex, setActiveIndex] = useState(0);

    const setItemRef = useCallback((index) => (el) => {
        itemRefs.current[index] = el;
    }, []);

    useEffect(() => {
        if (!containerRef.current || !itemCount) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const visible = entries
                    .filter((e) => e.isIntersecting)
                    .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

                if (visible) {
                    setActiveIndex(Number(visible.target.dataset.index));
                }
            },
            {
                root: containerRef.current,
                threshold,
            }
        );

        itemRefs.current.forEach((el) => el && observer.observe(el));

        return () => observer.disconnect();
    }, [itemCount, threshold]);

    return {
        containerRef,
        setItemRef,
        activeIndex,
    };
};

